import { tr } from "date-fns/locale";
import { MSMChatRequest, MSM_CHAT_BASE } from "../../api/msm";
import msm_api from "../../api/msm-api.json";
import { CHAT_MUTUO_ADD_MESSAGES, CHAT_MUTUO_SET_MESSAGES_UID } from "../actions/chatmutuo.actions";
import { createAsyncThunk } from "@reduxjs/toolkit";
import uniqueId from "lodash/uniqueId";

const getStream = async (data) => {
  const response = await fetch(
    `${MSM_CHAT_BASE}${msm_api.endpoint["ChatMutuo/ChatMessage"].url}`,
    {
      method: msm_api.endpoint["ChatMutuo/ChatMessage"].method,
      headers: msm_api.headers,
      body: JSON.stringify(data),
    }
  );
  if (!response.ok)
    {
      return new Error(response);
    }  
  return response.body;
};

async function* decodeStreamToJson(data) {
  if (!data) return;
  const reader = data.getReader();
  const decoder = new TextDecoder();
  while (true) {
    try {
      const { done, value } = await reader.read();
      if (done) break;
      let decoded = decoder
        .decode(value)
        .replace(/^\[/, "")
        .replace(/\]$/, "")
        .replace(/^\,/g, "")
        .replace(/\,$/g, "");
      decoded = decoded.split('},{"msg').map((item, index) => {
        let data = item;
        if (index > 0) {
          data = '{"msg' + data;
        }
        if (item.endsWith("}") && !item.endsWith("}}")) {
          data = data + "}";
        }
        return data;
      });
      for (const item of decoded) {
        if (item)
          try {
            yield JSON.parse(item);
          } catch (error) {
            //console.error("Error al analizar JSON:", item, error);
          }
      }
    } catch (error) {
      break;
    }
  }
}

export const CHAT_MUTUO_FETCH_MESSAGE = createAsyncThunk(
  "chatmutuo/chat/message/fetch/stream",
  async (args, thunkAPI) => {
    const { data } = args;
    const id = uniqueId("message-assistant-");
    thunkAPI.dispatch(
      CHAT_MUTUO_ADD_MESSAGES({
        Sender: "assistant",
        id,
        loading: true,
        error: false,
      })
    );

    const stream = await getStream({
      ...data,
      TonoConversazione:
        thunkAPI.getState().chatmutuo.messages.conversationType ||
        "PROFESSIONALE",
      Uid: thunkAPI.getState().chatmutuo.messages.uid || "",
      clientId: thunkAPI.getState().chatmutuo.messages.clientId || "",
      isMobile: thunkAPI.getState().chatmutuo.messages.isMobile || false
    });
    
    let isError = false;

    if(stream instanceof Error){
      isError = true;
    }
    else if (!stream) throw new Error();


    let incomingUID = thunkAPI.getState().chatmutuo.messages.uid || null;
    let fallbackMessage =
      "<p>Ops, qualcosa è andato storto. Aspetta qualche secondo e riprova oppure chiedimi qualcos'altro. Se vuoi invece trovare il tuo mutuo perfetto con il nostro preventivatore clicca <a href=\"/\">qui</a></p>";
//    "Ops, qualcosa è andato storto. Prova a chiedermi qualcos'altro o aspetta qualche secondo e riprova. Se non hai voglia di aspettare, cerca subito le migliori opzioni con il nostro preventivatore e trova la soluzione più adatta a te.";
    let completedMessage = fallbackMessage;
    let nRisposta = 0;
    let mRisposte = 0;
    const decodedStream = decodeStreamToJson(stream);

    let nChunk = 0;
    let lastUserMessage = thunkAPI.getState().chatmutuo.lastUserMessage || "";
    
    if(!isError){
      for await (const message of decodedStream) {
        nChunk++;
        if (message?.success && message.data.message.stato === "PARZIALE") {
          thunkAPI.dispatch(
            CHAT_MUTUO_ADD_MESSAGES({
              Messaggio: message.data.message.messaggio,
              Sender: message.data.message.sender,
              id,
              loading: true,
              error: false,
            })
          );

          if(message.data.uid !== null && incomingUID !== message.data.uid){
            incomingUID = message.data.uid;
            thunkAPI.dispatch(CHAT_MUTUO_SET_MESSAGES_UID(incomingUID));
          }

        } else if (
          message?.success &&
          message.data.message.stato === "COMPLETO"
        ) {
          nRisposta = message?.data?.numeroRisposta;
          mRisposte = message?.data?.maxRisposte;

          incomingUID = message.data.uid;
          completedMessage = message.data.message.messaggio;
          if (message.data.message?.links?.length > 0) {
            thunkAPI.dispatch(
              CHAT_MUTUO_ADD_MESSAGES({
                Data: {
                  titolo: message.data.message?.titolo || "",
                  elementi: message.data.message?.links || [],
                },
                Sender: "cms",
                id: uniqueId("message-cms-"),
              })
            );
          }
          break;
        } else {
          isError = true;
          break;
          //throw new Error("OH no");
        }
      }
    }

    isError = (nChunk === 0 || isError)
    
    if(isError)
    {
      if(lastUserMessage != ""){

        thunkAPI.dispatch(
          CHAT_MUTUO_ADD_MESSAGES({
            Data: {
              titolo: "",
              elementi: [{tipologia:"question",text: lastUserMessage, link:null}],
            },
            Sender: "cms",
            id: uniqueId("message-cms-"),
          })
        );
      }
    }
    return {
      success: true,
      incomingUID,
      completedMessage,
      id,
      nRisposta,
      mRisposte,
    };
  }
);

const fetchHistory = async (args, thunkAPI) => {
  try {
    const response = await MSMChatRequest("ChatMutuo/RecuperaChat", args);
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
};

export const CHAT_MUTUO_FETCH_HISTORY = createAsyncThunk(
  "chatmutuo/chat/messages/history/fetch",
  fetchHistory
);

// Stessa chiamata, ma la cronologia SOSTITUISCE i messaggi: lo store apparteneva
// a un documento caricato prima della chat (vedi useChatHistoryResync).
export const CHAT_MUTUO_RESYNC_HISTORY = createAsyncThunk(
  "chatmutuo/chat/messages/history/resync",
  fetchHistory
);
